import { styled } from '@mui/material/styles'

export const WidgetCard = styled('div')`
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;

	transition: all 0.2s ease;
	border-radius: 8px;
	box-shadow: none;
	border: none;

	&:hover {
		box-shadow: none;
	}
`

export const WidgetBody = styled('div')`
	flex: 1;
	overflow: visible;
	display: flex;
	flex-direction: column;
`
